import React from 'react';
import './loader.css';
import sherpaLoader from '../../../styles/img/sherpa.gif';

const PageLoader = () => {
  return (
    // <div className='preloader'>
    //   <div className='lds-ripple'>
    //     <div className='lds-pos'></div>
    //     <div className='lds-pos'></div>
    //   </div>
    // </div>
    <div className='contenedor-loader'>
      {/* <img src={Yaquis} /> YAAQUIS */}
      <img style={{ width: '40vw' }} src={sherpaLoader} />
    </div>
  );
};
export default PageLoader;
